import React, { useEffect } from 'react'
import { NavLink, Route, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Card, Container } from 'reactstrap'

// import { fetchCourses } from "containers/Course/actions";
// import { fetchGroups, fetchRoles } from "containers/Group/actions";
import { SETTINGS_MODULES as userSettingsModules } from '../../utils/helpers'
import GeneralConfig from 'views/pages/ConfigurationSettings/GeneralConfig'
import CourseConfig from 'views/pages/ConfigurationSettings/CourseConfig'
import ThemeConfig from 'views/pages/ConfigurationSettings/ThemeConfig'
import LanguageConfig from 'views/pages/ConfigurationSettings/LanguageConfig'
// Leon global Style
import '../../assets/css/Global/style.css'

const getDefaultTab = (defaultTab) => {
  switch (defaultTab) {
    case 'general':
      return 'general'
    case 'course':
      return 'course'
    case 'theme':
      return 'theme'
    case 'language':
      return 'language'
    default:
      return 'general'
  }
}

const ConfigContainer = (props) => {
  const language = useSelector((state) => state.language?.language)
  const languageData = useSelector((state) => state?.language)
  const user = useSelector((state) => state.auth.user)
  const generalConfig = useSelector((state) => state.generalConfig)
  const courseConfig = useSelector((state) => state.courseConfig)
  const users = useSelector((state) => state.users)
  const themeConfig = useSelector((state) => state.themeConfig)

  useEffect(() => {
    if (user.access === 1) {
      if (
        getDefaultTab(generalConfig.defaultTab) &&
        props.location.pathname === '/config'
      ) {
        props.history.push(`/config/${getDefaultTab(generalConfig.defaultTab)}`)
      }
    }
  }, [
    generalConfig.defaultTab,
    props.location.pathname,
    props.history,
    user.access,
  ])

  const { settingsModules } = users
  const modules = []

  const settingsModulesKeys = settingsModules?.map((item) => item.key)

  userSettingsModules.map((item) => {
    if (settingsModulesKeys?.includes(item.key)) {
      modules.push(item)
    }
  })

  const itemKeys = modules?.map((item) => item.key + '_settings')
  const languageSettingsModuleData = []

  language?.settings &&
    itemKeys?.map((item) => {
      languageSettingsModuleData.push(item)
    })
  // : null;

  userSettingsModules?.map((item) => {
    const languageItem = languageSettingsModuleData?.find(
      (subItem) => subItem[item] === item.key
    )
    if (languageItem) {
      item.name = languageSettingsModuleData[languageItem]
    }
  })

  return (
    <Container className='mt--6 ' fluid>
      <Card className='pt-3 shadow-none'>
        <div className='w-100'>
          <div className='settings-tabs dFlex md-flexCol textCenter gap-10 mb-0 mx-3 py-1 mb-3 '>
            {userSettingsModules.map((item, index) => (
              <NavLink key={index} activeClassName='current' to={`${item.to}`}>
                {item.name}
              </NavLink>
            ))}
          </div>
          {props.location.pathname === '/config' ? (
            user.access ? (
              [1].includes(user.access) ? (
                <Redirect from='/config' to='/config/general' />
              ) : null
            ) : null
          ) : null}

          {
            <div>
              {[1].includes(user.access) ? (
                <Route
                  exact
                  path='/config/general'
                  render={(props) => (
                    <GeneralConfig
                      {...props}
                      generalConfig={generalConfig}
                      language={language}
                    />
                  )}
                />
              ) : null}
              {[1].includes(user.access) ? (
                <Route
                  exact
                  path='/config/course'
                  render={(props) => (
                    <CourseConfig
                      {...props}
                      courseConfig={courseConfig}
                      language={language}
                    />
                  )}
                />
              ) : null}
              {[1].includes(user.access) ? (
                <Route
                  exact
                  path='/config/theme'
                  render={(props) => (
                    <ThemeConfig
                      {...props}
                      language={language}
                      user={user}
                      themeConfig={themeConfig}
                    />
                  )}
                />
              ) : null}
              {[1].includes(user.access) ? (
                <Route
                  exact
                  path='/config/language'
                  render={(props) => {
                    return language?.data ? (
                      <LanguageConfig
                        {...props}
                        language={language}
                        user={user}
                        languageData={languageData}
                      />
                    ) : null
                  }}
                />
              ) : null}
            </div>
          }
        </div>
      </Card>
    </Container>
  )
}

export default ConfigContainer
